export const contactsData = {
    email: 'raghv77+999@gmail.com',
    phone: '+9100000000',
    address: 'New Delhi India',

    sheetAPI: ''
}